import React, { useState, useEffect } from 'react'
import { Input } from 'antd'
import MyIcon from '../../../components/general/icon'
import MyDatePicker from '../../../components/forms/datePicker'

const FreshmenDeferralRibbon = ({
  filterValue,
  setFilterValue,
  isExportVisible
}) => {
  const [keywordsValue, setKeywordsValue] = useState('')
  const [searchBoxVisible, setSearchBoxVisible] = useState(false)

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setFilterValue({ ...filterValue, keywords: keywordsValue })
    }, 300)
    return () => clearTimeout(timeoutId)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keywordsValue])

  const handleBlur = () => {
    if (!keywordsValue) {
      setSearchBoxVisible(false)
      setFilterValue({ ...filterValue, keywords: '' })
    }
  }

  return (
    <div className='ribbon-page'>
      <div className='ribbon-container'>
        <div className='filter-addButton' onClick={() => { isExportVisible() }}>导出数据</div>

        <div className='ribbon-datePicker'>
          <MyDatePicker
            id="start_year"
            placeholder='选择开始时间'
            value={filterValue.start_year}
            onChange={setFilterValue}
            styles={{width: '200px', height: '32px'}}
            format = 'YYYY'
            picker="year"
          />
        </div>
        <div className='ribbon-datePicker'>
          <MyDatePicker
            id="end_year"
            placeholder='选择结束时间'
            value={filterValue.end_year}
            onChange={setFilterValue}
            styles={{width: '200px', height: '32px'}}
            format = 'YYYY'
            picker="year"
          />
        </div>
        

        {!searchBoxVisible ? 
          <div className='ribbon-condition' onClick={() => { setSearchBoxVisible(true) }}>
            <span><MyIcon name='sousuo'/></span>
            <p>搜索</p>
          </div>
        : <Input
            style={{width: '260px'}}
            prefix={<MyIcon name='sousuo'/>}
            maxLength={64}
            autoFocus
            placeholder='输入姓名或身份证号'
            value={keywordsValue}
            onChange={(e) => setKeywordsValue(e.target.value)}
            onBlur={handleBlur}
            allowClear
          />
        }
      </div>
    </div>
  )
}

export default FreshmenDeferralRibbon
